import { Link } from "react-router-dom";

export default function CommunityCta() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-container px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-950 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/30 blur-2xl" aria-hidden="true" />
          <div
            className="absolute -bottom-20 right-24 h-48 w-48 rounded-full bg-accent-500/20 blur-2xl"
            aria-hidden="true"
          />
          <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-300">
                <span className="h-px w-6 bg-accent-400" aria-hidden="true" />
                参与讨论
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                手里有料？把它投到爆料社区
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200/85 md:text-base">
                支持匿名投稿，编辑会协助整理线索与措辞。我们更在意信息是否完整、是否可核实，而不是标题够不够劲爆。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
              <Link
                to="/about#submit"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-send-plane-line" aria-hidden="true" />
                前往投稿
              </Link>
              <Link
                to="/faq"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-question-line" aria-hidden="true" />
                投稿规则
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}